import { certifications } from "api/certified-api";

/**
 * Genera los encabezados comunes para las peticiones.
 * @param {string} token - Token JWT.
 * @returns {Object} Headers estándar.
 */
const getHeaders = (token) => ({
	'Content-Type': 'application/json',
	'Accept': 'application/json',
	'x-access-token': token
});

/**
 * Obtiene una certificación por su ID.
 */
export const fetchCertificationById = async (id, token) => {
	const response = await certifications.get(`/${id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Obtiene todas las certificaciones asociadas a un usuario.
 */
export const fetchCertificationsByUserId = async (user_id, token) => {
	const response = await certifications.get(`/user/${user_id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Actualiza las fechas de una certificación.
 */
export const updateCertificationDatesById = async (id, data, token) => {
	const response = await certifications.put(`/dates/${id}`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Actualiza el estado de una certificación.
 */
export const updateCertificationStatusById = async (id, data, token) => {
	const response = await certifications.put(`/status/${id}`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Marca una certificación como completada.
 */
export const updateCertificationCompletedById = async (id, data, token) => {
	const response = await certifications.put(`/completed/${id}`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Actualiza el archivo generado para la certificación (PDF de resultado).
 */
export const updateCertFileByCertificationId = async (id, data, token) => {
	const response = await certifications.put(`/emet/results/certification/file/${id}`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};


export const updateEpstCertFileByCertificationId = async (id, data, token) => {
	const response = await certifications.put(`/epst/result/certification/file/${id}`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Crea una nueva certificación.
 */
export const createCertification = async (data, token) => {
	const response = await certifications.post(`/`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Crea un resultado para EMeT.
 */
export const createEmetResult = async (data, token) => {
	const response = await certifications.post(`/emet/results`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Genera el certificado de EMeT.
 */
export const generateEmetResult = async (data, token) => {
	const response = await certifications.post(`/emet/certificate/generate`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

export const generateEpstResult = async (data, token) => {
	const response = await certifications.post(`/epst/certificate/generate`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Marca como finalizada la certificación EMeT.
 */
export const generateEmetFinish = async (data, token) => {
	const response = await certifications.post(`/emet/certificate/finish`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Marca como finalizada la certificación EPSt.
 */
export const generateEpstFinish = async (data, token) => {
	const response = await certifications.post(`/epst/certificate/finish`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Registra un error en la certificación.
 */
export const generateCertificationError = async (data, token) => {
	const response = await certifications.post(`/certification/error`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Elimina una certificación por su ID.
 */
export const deleteCertificationById = async (id, token) => {
	const response = await certifications.delete(`/${id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};